import { useEffect, useState } from 'react';

// import getEmbedToken from '../Analyze/supplydemand/getEmbedToken';
import { Box, Typography } from "@mui/material";
import { models } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";
import axios from 'axios';
import { get } from 'lodash';
import '../../powerbi/SiMSPowerBiEmbedComponent.css';
import {
  API_URL,
  POWERBI_REPORT_ID_SDD,
  POWERBI_GROUP_ID_SDD,
  POWERBI_DATASET_ID_SDD,
} from "@/config/env";

/*https://stackoverflow.com/questions/52981450/power-bi-embed-error-403-forbidden-error-from-server*/

 const SiMSPowerBiEmbedComponent = () => { 
   const clientId = '92082249-7471-4cfb-a47f-add6014c0451';
   const clientSecret = 'pDE8Q~jaY4kel_T6K1WNkGWqONBVI9gOnRwW5aL~';
   const authority = 'https:login.microsoftonline.com/5989ece0-f90e-40bf-9c79-1a7beccdb861';
   const scopeBase = 'https:analysis.windows.net/powerbi/api/.default';
   const workspaceId = '6643507a-d35d-4f72-aa16-a61197b8ff1a';

   const reportId = POWERBI_REPORT_ID_SDD;
   const groupId = POWERBI_GROUP_ID_SDD;
   const datasetId = POWERBI_DATASET_ID_SDD;


   const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [accessToken, setAccessToken] = useState(null);
    const [pbiObj, setPbiObj] = useState(null);
    const [powerbireportId, setReportId] = useState(null);
    const [powerbidatasetId, setDatasetId] = useState(null);
    const [embedToken, setEmbedToken] = useState(null);
    const [datasetDetails, setDatasetDetails] = useState(null);
    const [embedConfig, setEmbedConfig] = useState(null);
    const [embedUrl, setEmbedUrl] = useState(null);
    const [embedType, setEmbedType] = useState(null);
    const [embedId, setEmbedId] = useState(null);
    const [embedSettings, setEmbedSettings] = useState(null);
    const [embedBackground, setEmbedBackground] = useState(null);


  
  /*
useEffect(() => {
  fetch('https://www.dev-ucbsims.solutions.iqvia.com/powerapi/api/Admin/GetPowerBIEmbedTokenV3')
  .then((response) => response.json())
  .then((data) => {
    //alert('embed token starts' + data.token);
    console.log('embed token for sims powerbi sdd report--> ' + JSON.stringify(data));
  setEmbedToken(data.token);
  console.log('Embed Token:', data.token);
  })
  .catch((err) => {
  console.error(err.message);
  });
  }, []);
     
  */


  useEffect(() => {
    const autherization = localStorage.getItem("data");
    const data = JSON.parse(autherization);
    const email= data.email;
    const userId= data.userId;
    const token = data.token;
    console.log('email from local storage for SDD: ' + email);
    //alert(email);
    const powerBiBaseUrl = API_URL;
    const fullUrl = `${powerBiBaseUrl}Admin/GetPowerBIEmbedTokenV3?email=${email}`;

    fetch(fullUrl, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
         Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        email: email,
        
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Success:', data);
      setEmbedToken(data.token);
    }
    )
    .catch((error) => {   
      console.error('Error:', error);
      setError(error);
    }
    );
  }, []);
    
     

     return (
           		   
        <div id="powerbi-embed-container">
                  <PowerBIEmbed 
                     embedConfig={{
                        type: 'report',
                        id: reportId,
                        embedUrl: `https://app.powerbi.com/reportEmbed?reportId=${reportId}&groupId=${groupId}`,
                        
                        accessToken:  embedToken,
                        datasetId: datasetId, 
                        tokenType: models.TokenType.Embed, 
                        settings: {
                          filterPaneEnabled: false,
						              navContentPaneEnabled: false,
                        },
                        background: models.BackgroundType.Transparent,
                     }}
                     eventHandlers = {
                      new Map([
                          ['loaded', function () {console.log('Report loaded');}],
                          ['rendered', function () {console.log('Report rendered');}],
                          ['error', function (event) {console.log(event.detail);}],
                          ['visualClicked', () => console.log('visual clicked')],
                          ['pageChanged', (event) => console.log(event)],
                      ])
                  }
                  cssClassName = { "bi-embedded" }
                  getEmbeddedComponent = { (embeddedReport) => {
                    window.report = embeddedReport; // save report in window object
                }}
                  
                  />
               
                </div> 
       
              
       
     );
  
  
  
   
   
 };



 export default SiMSPowerBiEmbedComponent;  
